/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  OktaServerSuggestion,
  OktaServerSuggestion$inboundSchema,
} from "./oktaserversuggestion.js";

export type ListOktaServerSuggestionsResult = {
  /**
   * The organization's identity provider connection the snapshot came from.
   */
  connectionId?: string | undefined;
  /**
   * Suggestions the administrator has not acted on.
   */
  openCount: number;
  /**
   * When the applications snapshot was last synced; the suggestions are only as fresh as it.
   */
  snapshotAt?: Date | undefined;
  /**
   * Open suggestions first, then by server name. By default only open ones; include_all adds dismissed and installed.
   */
  suggestions: Array<OktaServerSuggestion>;
  /**
   * Matching entries before filtering.
   */
  totalCount: number;
};

/** @internal */
export const ListOktaServerSuggestionsResult$inboundSchema: z.ZodMiniType<
  ListOktaServerSuggestionsResult,
  unknown
> = z.pipe(
  z.object({
    connection_id: z.optional(z.string()),
    open_count: z.int(),
    snapshot_at: z.optional(
      z.pipe(z.iso.datetime({ offset: true }), z.transform(v => new Date(v))),
    ),
    suggestions: z.array(OktaServerSuggestion$inboundSchema),
    total_count: z.int(),
  }),
  z.transform((v) => {
    return remap$(v, {
      "connection_id": "connectionId",
      "open_count": "openCount",
      "snapshot_at": "snapshotAt",
      "total_count": "totalCount",
    });
  }),
);

export function listOktaServerSuggestionsResultFromJSON(
  jsonString: string,
): SafeParseResult<ListOktaServerSuggestionsResult, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ListOktaServerSuggestionsResult$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ListOktaServerSuggestionsResult' from JSON`,
  );
}
